// src/components/Admin/VirtualScenes/SceneItems.js
import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
//import { VirtualScenes } from "../../../../api";
//import { useAuth } from "../../../../hooks";
import { MultiStepForm } from "../SceneForm";
import "./SceneItems.scss";

//const virtualSceneController = new VirtualScenes();

export function SceneItems(props) {
  const { scene, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  //const { accessToken } = useAuth();

  const openUpdateScene = () => {
    setIsUpdateMode(true);
    setShowModal(true);
  };

  function formatCategories(categories) {
    return categories.join(" ");
  }

  return (
    <>
      <div className="scene-item">
        <div className="scene-item__image">
          <img
            src={scene.bannertopUrl}
            alt={scene.title}
            loading="lazy"
          />
        </div>
        <div className="scene-item__content">
          <h2 className="scene-item__title">{scene.title}</h2>
          <p className="scene-item__categories">
            {formatCategories(scene.category)}
          </p>
          <p className="scene-item__categories">
            {formatCategories(scene.subcategory)}
          </p>
          <div className="scene-item__buttons">
            {/* Ver */}
            <Button
              icon
              as="a"
              href={scene.urlsala}
              target="_blank"
              className="btn-icon scene-item__btn-view"
            >
              <Icon name="eye" />
            </Button>
            {/* Editar */}
            <Button
              icon
              onClick={openUpdateScene}
              className="btn-icon scene-item__btn-edit"
            >
              <Icon name="pencil" />
            </Button>
          </div>
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={() => setShowModal(false)}
        title={
          <>
            Editando {scene.title}
            <br />
            {scene.account}
          </>
        }
      >
        <MultiStepForm
          scene={scene}
          onClose={() => setShowModal(false)}
          onReload={onReload}
          isUpdateMode={isUpdateMode}
        />
      </BasicModal>
    </>
  );
}
